var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95038 6.08804C8.2413 4.31844 10.7762 3.35035 13.006 3.19464C15.2401 3.03864 17.1065 3.69614 18.1869 5.09479C19.2671 6.4934 19.4314 8.46485 18.7162 10.5868C18.0024 12.705 16.4254 14.9132 14.1345 16.6829C11.8435 18.4526 9.30791 19.4212 7.07806 19.5769C4.84447 19.7327 2.97892 19.0752 1.89856 17.6769C0.818245 16.2784 0.65283 14.3067 1.36787 12.1847C2.08176 10.0665 3.65943 7.85771 5.95038 6.08804Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.34,
    height: 21.34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring_icon.a5022fe8b5d27a2b38fe1ad8ea1b63e9.svg";
export { ForwardRef as ReactComponent };